export default function discountPercentage(original: number, discounted: number) {
  if (!original) {
    return 0
  }
  // return 2dp discount percentage
  return Math.round((1 - discounted / original) * 10000) / 100
}
